module.exports = __webpack_public_path__ + "static/img/logo-light-horizontal.ed79fc6.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo-light-horizontal.png
// module id = 138
// module chunks = 17